"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const selector_1 = require("@pulse-web-ui/selector");
const theme_1 = require("@pulse-web-ui/theme");
const react_1 = __importStar(require("react"));
const react_svg_1 = require("react-svg");
const selector_card_styles_1 = require("./selector-card.styles");
require("./selector-card.types");
const SuccessCheck = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('@pulse-web-ui/icons/lib/lazy/rgs-check'))));
const Icon = ({ selectorProps: { id, name, checked, disabled, error }, readOnly, iconPath, }) => {
    const theme = (0, theme_1.useTheme)();
    if (readOnly && iconPath) {
        return (react_1.default.createElement(react_svg_1.ReactSVG, { src: iconPath, beforeInjection: (svg) => {
                svg.setAttribute('style', 'width: 24px');
                svg.setAttribute('style', 'height: 24px');
            } }));
    }
    if (readOnly) {
        return (react_1.default.createElement(react_1.Suspense, { fallback: null },
            react_1.default.createElement(selector_card_styles_1.IconContainer, null,
                react_1.default.createElement(SuccessCheck, { color: theme.colors.accent.success.normal, width: 13, viewBox: "0 0 13 11" }))));
    }
    return (react_1.default.createElement(selector_1.Selector, { id: id, name: name, checked: checked, disabled: disabled, error: error, readOnly: true }));
};
exports.Icon = Icon;
